import { render, staticRenderFns } from "./AssigneeSelector.vue?vue&type=template&id=10e0427c"
import script from "./AssigneeSelector.vue?vue&type=script&lang=js"
export * from "./AssigneeSelector.vue?vue&type=script&lang=js"
import style0 from "./AssigneeSelector.vue?vue&type=style&index=0&id=10e0427c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports